import { graphql } from '../graphql/generated';

export const MARK_PRINTED_MUTATION = graphql(`
  mutation MarkPrinted($requestId: ID!, $beforeSend: Boolean!) {
    markPrinted(requestId: $requestId, beforeSend: $beforeSend) {
      id
    }
  }
`);
